// IDs. Zufällige IDs kommen aus sync.mjs (cryptoId). Hier: feste IDs aus einem Text, damit dieselbe Übernahme (Prototyp-Stand, Wechsel des Kontos)
// bei einer Wiederholung dieselben Ereignis-IDs erzeugt und dadurch keine Dubletten entstehen.
import { cryptoId } from '../../platform/sync/sync.mjs';

// cyrb128: einfacher, schneller 128-Bit-Hash (kein Kryptoverfahren; reicht, um IDs eindeutig und wiederholbar zu machen)
function cyrb128(str) {
  let h1 = 1779033703, h2 = 3144134277, h3 = 1013904242, h4 = 2773480762;
  for (let i = 0, k; i < str.length; i++) {
    k = str.charCodeAt(i);
    h1 = h2 ^ Math.imul(h1 ^ k, 597399067); h2 = h3 ^ Math.imul(h2 ^ k, 2869860233);
    h3 = h4 ^ Math.imul(h3 ^ k, 951274213); h4 = h1 ^ Math.imul(h4 ^ k, 2716044179);
  }
  h1 = Math.imul(h3 ^ (h1 >>> 18), 597399067); h2 = Math.imul(h4 ^ (h2 >>> 22), 2869860233);
  h3 = Math.imul(h1 ^ (h3 >>> 17), 951274213); h4 = Math.imul(h2 ^ (h4 >>> 19), 2716044179);
  h1 ^= h2 ^ h3 ^ h4; h2 ^= h1; h3 ^= h1; h4 ^= h1;
  return [h1 >>> 0, h2 >>> 0, h3 >>> 0, h4 >>> 0];
}

// UUID im Format 8-4-4-4-12 (Version 8 = „eigenes Verfahren“, Variante RFC 4122), passt in die Spalte review_events.id (uuid).
export function stableUuid(text) {
  const hex = cyrb128(text).map(n => n.toString(16).padStart(8, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-8${hex.slice(13, 16)}-${((parseInt(hex[16], 16) & 0x3) | 0x8).toString(16)}${hex.slice(17, 20)}-${hex.slice(20, 32)}`;
}

export const randomId = cryptoId;

// Geräte-ID: einmal je Browser erzeugt, für alle Konten auf diesem Gerät gleich (steht in jedem Ereignis, hilft bei der Fehlersuche).
export function deviceId(store) {
  let id = store.get('sentenzo.device');
  if (!id) { id = cryptoId(); store.set('sentenzo.device', id); }
  return id;
}
